import round10Decimals from "./round10Decimals";

const round2Decimals = (num) => {
  const nuevoNumber = round10Decimals(num);
  const factor = 100;
  const scaled = Number((nuevoNumber * factor).toPrecision(15));
  return Math.round(scaled) / factor;
};

export default round2Decimals;